import { createEvent, createStore } from "effector";
import { AppConfig } from "../../config";
import { endSession } from "./endSession";

type Countdown = {
  enabled: boolean;
  seconds: number;
  intervalId: number | null;
  expired: boolean;
};
const initialState: Countdown = {
  enabled: false,
  seconds: 0,
  intervalId: null,
  expired: false,
};
export const $countdown = createStore<Countdown>(initialState);

const dec = createEvent();
$countdown.on(dec, (store) => {
  const seconds = store.seconds - 1;
  if (seconds === 0) {
    endSession();
    return {
      enabled: false,
      seconds: 0,
      expired: true,
      intervalId: null,
    };
  }
  return {
    ...store,
    enabled: true,
    expired: false,
    seconds,
  };
});

const start = createEvent();
$countdown.on(start, (store) => {
  if (store.enabled) return { ...store };
  const intervalId = window.setInterval(() => {
    dec();
  }, 1000);
  return {
    intervalId,
    enabled: true,
    expired: false,
    seconds: AppConfig.countdownDuration * 60,
  };
});

const stop = createEvent();
$countdown.on(stop, (store) => {
  if (store.intervalId) {
    clearInterval(store.intervalId);
  }
  return initialState;
});

export const countdownApi = {
  start,
  stop,
};
